import { ModalApi } from "components/modal/Modal";
import SpendingPowerModal from "components/modal/SpendingPowerModal";
import { BaseButton } from "components/ui/Button";
import Icon from "components/ui/Icon";
import UILabel from "components/ui/UILabel";
import React, { useRef } from "react";
import { getOnboarding } from "store/api/apiSlice";
import styled from "styled-components";
import { ApiDashboard } from "utils/api/dashboard";
import { ApiUsersProduct, ApiUsersProfile } from "utils/api/users";
import { formatDateString } from "utils/date";
import { formatCurrency } from "utils/string";
import * as Styled from "./styled";

const Wrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0;
  margin: 0;

  list-style: none;
`;

const LineItemText = styled(UILabel.Medium)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const LineItemValue = styled(LineItemText).attrs(() => ({
  bold: true,
  color: "primary",
}))``;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 12px;
`;

const LineItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

interface Props {
  dashboard: ApiDashboard;
  userProfile: ApiUsersProfile;
}

const LineItems: React.FC<Props> = ({ dashboard, userProfile }) => {
  const spendingPowerModal = useRef<ModalApi>(null);
  const onboarding = getOnboarding();
  const isOnboardingComplete = onboarding.data?.complete;
  const isEwaFlex = userProfile.product === ApiUsersProduct.ewaFlex;

  return (
    <Wrapper>
      {isEwaFlex && (
        <LineItem>
          <LineItemText>
            Card Spending Power
            {isOnboardingComplete && (
              <IconWrapper>
                <Styled.IconButtonWrapper>
                  <BaseButton
                    onClick={() => spendingPowerModal.current?.show()}
                  >
                    <Icon name="questionCircleDuo" />
                  </BaseButton>
                </Styled.IconButtonWrapper>
              </IconWrapper>
            )}
          </LineItemText>
          <LineItemValue>
            ${formatCurrency(dashboard?.safeToSpend)}
          </LineItemValue>
        </LineItem>
      )}

      {!isEwaFlex && (
        <LineItem>
          <LineItemText>Accrued Net Earnings</LineItemText>
          <LineItemValue>
            ${formatCurrency(dashboard?.accruedNetEarnings)}
          </LineItemValue>
        </LineItem>
      )}

      <LineItem>
        <LineItemText>Next Payday</LineItemText>
        <LineItemValue>
          {formatDateString(dashboard?.nextPayday, "numericShort")}
        </LineItemValue>
      </LineItem>

      <SpendingPowerModal ref={spendingPowerModal} />
    </Wrapper>
  );
};

export default LineItems;
